module.exports = __webpack_public_path__ + "static/media/word.80036ad0.svg";